module.exports = __webpack_public_path__ + "img/andMe.de5eb3ae.png";